


















































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import {
  APPROVE_ALL_FORMS,
  APPROVE_SELECTED_FORMS,
  MANAGER_LOADING,
  OPEN_APPROVE_FORMS_MODAL,
  OPEN_APPROVE_FORMS_MODAL_ERRORS,
  SELECTED_FORMS_TO_APPROVE,
  SET_MANAGER_LOADING,
  SET_OPEN_APPROVE_FORMS_MODAL,
  SET_OPEN_APPROVE_FORMS_MODAL_ERRORS,
  SET_SELECTED_FORMS_TO_APPROVE,
} from '@/types/managerForm.types';
import { ApproveFormRequest } from '@/models/manager/ApproveFormRequest';
import Spinner from '@/components/loading/Spinner.vue';

@Component({
  components: {
    Spinner,
  },
})
export default class ApproveFormsModal extends Vue {

  @Action(APPROVE_ALL_FORMS, StoreNamespace.MANAGER) public approveAllForms;
  @Action(APPROVE_SELECTED_FORMS, StoreNamespace.MANAGER) public approveSelectedForms;

  @Mutation(SET_OPEN_APPROVE_FORMS_MODAL, StoreNamespace.MANAGER) public setOpenApproveFormsModal;
  @Mutation(SET_SELECTED_FORMS_TO_APPROVE, StoreNamespace.MANAGER) public setSelectedFormsToApprove;
  @Mutation(SET_OPEN_APPROVE_FORMS_MODAL_ERRORS, StoreNamespace.MANAGER) public setOpenApproveFormsModalErrors;
  @Mutation(SET_MANAGER_LOADING, StoreNamespace.MANAGER) public setManagerLoading;

  @Getter(OPEN_APPROVE_FORMS_MODAL, StoreNamespace.MANAGER) public openApproveFormsModal!: boolean;
  @Getter(OPEN_APPROVE_FORMS_MODAL_ERRORS, StoreNamespace.MANAGER) public serverErrorMessages!: string[];
  @Getter(SELECTED_FORMS_TO_APPROVE, StoreNamespace.MANAGER) public selectedFormsToApprove!: ApproveFormRequest[];
  @Getter(MANAGER_LOADING, StoreNamespace.MANAGER) public managerLoading!: boolean;

  private approveAll = false;

  public mounted() {
    this.setOpenApproveFormsModalErrors([]);
    this.approveAll = !this.selectedFormsToApprove.length;
  }

  public closeDialog(): void {
    this.setOpenApproveFormsModal(false);
    this.setSelectedFormsToApprove([]);
  }

  public confirmDialog() {
    this.setManagerLoading(true);
    if (this.approveAll) {
      this.approveAllForms();
    } else {
      this.approveSelectedForms(this.selectedFormsToApprove);
    }

    this.closeDialog();
  }

  public destroyed() {
    this.setOpenApproveFormsModal(false);
  }

}
